import * as z from 'zod'

export const bookingSchema = z
  .object({
    arrive: z.string(),
    depart: z.string(),
    prettyId: z.string(),
    status: z.number(),
    token: z.string(),
    categories: z.string().array().optional(),
    primaryPhoto: z
      .object({
        url: z.object({
          masterImage: z.string(),
        }),
      })
      .optional(),
    isBYO: z.boolean().optional(),
    unitType: z
      .object({
        id: z.string(),
        name: z.string(),
        slug: z.string(),
      })
      .optional()
      .nullable(),
    partyDetailed: z
      .object({
        adults: z.number(),
        children: z.number(),
        childrenAges: z.number().array(),
        infants: z.number(),
        infantAges: z.number().array(),
        dogs: z.number(),
        display: z.string(),
      })
      .optional(),
    pitchtype: z
      .object({
        name: z.string(),
        categories: z.array(
          z.object({
            id: z.string(),
          }),
        ),
        primaryPhoto: z
          .object({
            url: z.object({
              master_image: z.string(),
              galleryLarge: z.string(),
              galleryMedium: z.string(),
              gallerySmall: z.string(),
              userPhoto: z.string(),
            }),
          })
          .optional(),
      })
      .optional(),
    campsite: z
      .object({
        id: z.number(),
        slug: z.string(),
        rating: z.number().optional().nullable(),
        rateCount: z.number().optional().nullable(),
        name: z.string(),
        fullAddress: z.string(),
        primaryPhoto: z
          .object({
            url: z.object({
              master_image: z.string(),
              galleryLarge: z.string(),
              galleryMedium: z.string(),
              gallerySmall: z.string(),
              userPhoto: z.string(),
            }),
          })
          .optional(),
        path: z.string(),
      })
      .optional(),
  })
  .optional()
  .nullable()

export const guestBookingSchema = z.object({
  error: z.string(),
  booking: bookingSchema,
  reviewId: z.string().optional().nullable(),
})

export type GuestBooking = z.infer<typeof guestBookingSchema>
export type GuestBookingBooking = z.infer<typeof bookingSchema>
